export const initialDeviceListLoaded = (state) => {
  return state.applicationState.initialDeviceListLoaded;
};

export const getInitialDeviceId = (state) => {
  return state.applicationState.initialDeviceId;
};
